import React from "react";
import { Stack, styled, Typography } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import EmailInfoPopup from "./EmailInfoPopup";

const StyledStack = styled(Stack)`
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const EmailItem = ({
  emailObj,
  onEmailDeleted,
}) => {
  return (
    <ListItem style={{ padding: "5px 0" }}>
      <StyledStack>
        <Stack
          direction="row"
          alignItems="center"
          gap="5px">
          <Typography
            component="p"
            variant="body1">
            {emailObj.email}
          </Typography>
          <EmailInfoPopup
            emailObj={emailObj}
            onEmailDeleted={onEmailDeleted}/>
        </Stack>
      </StyledStack>
    </ListItem>
  );
};

export default EmailItem;